import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import {CUSTOM_SCROLL, CUSTOM_SCROLL_LOCK, isIe11, scrollSetting} from "../../common/globalVars";
import {CustomEventHandler} from "../../utils/CustomEventHandler";

export default class ScrollControl {
    constructor() {
        this.gsapScrollTween = undefined;
        this.prevY = 0;
        this.setAppFix();
        this.scrollSave = -1;
        gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

        if (!scrollSetting.smooth) {
            this.setControl();
        } else {
            this.setSmoothScroll();
        }

        // todo: 신형주 : 백 버튼을 누르거나 새로고침 할경우 스크롤이 튀는 현상 방지를 위해 넣음 hash 처리쪽과 중첩 되므로 추후 수정이 필요 해보임
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }

        console.log('scroll-control init');
        window.onhashchange = ()=>{this.onHashChangeHandler()};
        window.addEventListener(CUSTOM_SCROLL_LOCK, (e) => this.onScrollLockHandler(e));
    }

    getHashScrollY() {
        let returnValue = -1;
        let hash = window.location.hash.split('#')[1];
        if (hash) {
            let el = document.getElementById(hash);
            // console.log(el.getBoundingClientRect().top);
            if (el) {
                // returnValue = el.getBoundingClientRect().top;
                returnValue = el.offsetTop;
                return returnValue;
            }
        }
        return returnValue;
    }

    setHeight() {
        this.height = this.container.getBoundingClientRect().height;
        // console.log('setHeight ' + this.height + ' : ' + this.container.offsetHeight);
        document.body.style.height = this.height + 'px';
    }

    setAppFix() {
        if (scrollSetting.smooth) {
            let viewport = document.getElementById('viewport');
            viewport.style.position = 'fixed';
            viewport.style.height = '100%';
        }
        this.container = document.querySelector('.app');
    }

    setContainer(el) {
        if (scrollSetting.smooth) {
            this.container = el;
            this.setHeight();
            this.hashFirst = true;
            this.onHashChangeHandler();
            // this.setGsapScroll();

            this.onResizeHandler();

            CustomEventHandler.addHandler(window, 'resize', ()=>this.onResizeHandler());
        } else {
            this.onHashChangeHandler();
        }
    }

    setControl() {
        window.addEventListener('scroll', (e)=>this.onScrollHandler(e));
    }

    onHashChangeHandler() {
        let hashY = this.getHashScrollY();
        // console.log('--->' + hashY);
        if (hashY >= 0) {
            this.hashY = hashY;
            window.scrollTo(0, hashY);
            return;
        }

        this.hashY = 0;
        console.log('hash changed : ' + hashY);
    }

    setSmoothScroll() {
        window.addEventListener('scroll', ()=>this.onSmoothScrollHandler());
    }

    onSmoothScrollHandler() {
        // console.log('hashY ======> ' + this.hashY);
        let duration = 0.5;
        if ((this.hashY > 0)&&(this.hashFirst)) {
            duration = 0;
            this.hashY = 0;
            this.hashFirst = false;
        }

        if (this.gsapScrollTween) {
            this.gsapScrollTween.kill();
            this.gsapScrollTween = null;
        }

        let scrollY = isIe11()?window.pageYOffset:window.scrollY;
        this.gsapScrollTween = gsap.to(
            this.container, {
                y: scrollY * -1,
                duration:duration,
                ease:'ease-out',
                onUpdate:(e)=>{
                    this.render(e);
                }
            }
        );
    }

    render() {
        let y = gsap.getProperty(this.container, 'y');
        // console.log(y);

        this.scrollTop = y*-1;
        let evt = new CustomEvent(CUSTOM_SCROLL, {detail:y*-1});

        window.dispatchEvent(evt);
    }

    onScrollHandler() {
        if (Math.abs(this.prevY - window.scrollY) < 1) return;
        this.prevY = window.scrollY;

        let y = this.scrollTop = window.scrollY;

        let evt = new CustomEvent(CUSTOM_SCROLL, {detail:y});
        window.dispatchEvent(evt);
    }

    onResizeHandler() {
        if (scrollSetting.smooth) {
            this.setHeight();
        }
        // console.log('scroll control - resize');
        this.onScrollHandler();
    }

    onScrollLockHandler(e) {
        let viewport = document.getElementById('viewport');
        if (e.detail) {
            console.log('custom scroll lock');
            this.scrollSave = this.scrollTop;
            if (scrollSetting.smooth) {
                document.body.style.height = '100vh';
                viewport.style.height = '100vh';
            } else {
                document.querySelector('.sec-tablet-sub').style.height = viewport.style.height = window.innerHeight + 'px';
                viewport.style.overflow = 'hidden';
            }
        } else {
            // console.log('custom scroll unlock');
            if (scrollSetting.smooth) {
                this.onResizeHandler();
            } else {
                viewport.style.height = 'auto';
                viewport.style.overflow = 'visible';
            }
            if (this.scrollSave !== -1) {
                window.scrollTo(0, this.scrollSave);
                this.scrollSave = -1;
            }
        }
    }
}
